<template>
	<div id="story-body-controls">
		<a
			v-if="$store.state.user.authUser && storyAlreadyBookmarked(story)"
			class="card-action-link"
			href="#"
			@click.prevent="handleAction('unsave', story)"
		>
			<MdBookmarkIcon class="control-link-active" title="Unsave" />
		</a>
		<a
			v-else-if="$store.state.user.authUser && !storyAlreadyBookmarked(story)"
			class="card-action-link save-link"
			href="#"
			@click.prevent="handleAction('save', story)"
		>
			<MdBookmarkIcon class="control-link" title="Save" />
		</a>
		<a v-else class="card-action-link save-link" href="#" @click.prevent="showModal('save')">
			<MdBookmarkIcon class="control-link" title="Save" />
		</a>

		<!-- Sharing and unsharing-->
		<div v-if="$store.state.user.authUser">
			<a
				v-if="storyAlreadyShared(story)"
				class="card-action-link active-control-link"
				href="#"
				@click.prevent="handleAction('unshare', story)"
			>
				<MdShareAltIcon class="control-link-active" title="Unshare" />
			</a>
			<a
				v-else
				class="card-action-link share-link"
				href="#"
				@click.prevent="handleAction('share', story)"
			>
				<MdShareAltIcon class="control-link" title="Share" />
			</a>
		</div>
		<div v-else>
			<a class="card-action-link share-link" href="#" @click.prevent="showModal('share')">
				<MdShareAltIcon class="control-link" title="Share" />
			</a>
		</div>

		<!-- Liking and Unliking -->
		<div v-if="$store.state.user.authUser">
			<a
				v-if="storyAlreadyLiked(story)"
				class="card-action-link active-control-link"
				href="#"
				@click.prevent="handleAction('unlike', story)"
			>
				<MdHeartIcon class="control-link-active" title="Unlike" />
			</a>
			<a
				v-else
				class="card-action-link like-link"
				href="#"
				@click.prevent="handleAction('like', story)"
			>
				<MdHeartEmptyIcon class="control-link" title="Like" />
			</a>
		</div>
		<div v-else>
			<a class="card-action-link like-link" href="#" @click.prevent="showModal('like')">
				<MdHeartEmptyIcon class="control-link" title="Like" />
			</a>
		</div>
	</div>
</template>

<script>
import { storyMixin } from "../../mixins/storyMixin";
import { mapGetters } from "vuex";
import MdBookmarkIcon from "vue-ionicons/dist/md-bookmark.vue";
import MdShareAltIcon from "vue-ionicons/dist/md-share-alt.vue";
import MdHeartIcon from "vue-ionicons/dist/md-heart.vue";
import MdHeartEmptyIcon from "vue-ionicons/dist/md-heart-empty.vue";

export default {
	mixins: [storyMixin],
	props: {
		story: {
			type: Object
		},
		from: {
			type: String
		}
	},
	components: {
		MdBookmarkIcon,
		MdShareAltIcon,
		MdHeartIcon,
		MdHeartEmptyIcon
	},
	computed: {
		sameUsername() {
			return (
				this.$store.state.user.user.username === this.$route.params.username
			);
		},
		...mapGetters({
			likedStories: "getUserLikes",
			sharedStories: "getUserShares",
			bookmarkedStories: "getUserBookmarks"
		})
	},
	methods: {
		showModal(action) {
			const html = document.querySelector("html");
			const app = document.querySelector("#app");
			app.classList.add("blur-app");
			html.style.overflowY = "hidden";

			let payload = {
				show: true,
				action: action
			};

			this.$store.commit("updateAccountModal", payload);
		},
		handleAction(action, story) {
			if (this.$store.state.user.authUser.emailVerified) {
				switch (action) {
					case "share":
						this.share(story);
						break;
					case "unshare":
						this.unshare(story);
						break;
					case "like":
						this.like(story);
						break;
					case "unlike":
						this.unlike(story);
						break;
					case "save":
						this.bookmark(story);
						break;
					case "unsave":
						this.unBookmark(story);
						break;
				}
			} else {
				this.showModal("verify-email");
			}
		},
		storyAlreadyShared(story) {
			const isStoryShared = this.sharedStories.some(
				sharedStory => sharedStory.url === story.url
			);
			return isStoryShared;
		},
		storyAlreadyLiked(story) {
			const isStoryLiked = this.likedStories.some(
				likedStory => likedStory.url === story.url
			);
			return isStoryLiked;
		},
		storyAlreadyBookmarked(story) {
			const isStoryBookmarked = this.bookmarkedStories.some(
				bookmarkedStory => bookmarkedStory.url === story.url
			);
			return isStoryBookmarked;
		}
	}
};
</script>

<style scoped>
#story-body-controls {
	position: sticky;
	position: -webkit-sticky;
	top: 150px;
	height: fit-content;
	background-color: #171717;
	padding: 20px 10px 10px;
	border-radius: 20px;
	margin-right: 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.story-body-controls a {
	display: block;
	margin-bottom: 5px;
}

.card-action-link {
	margin-left: 0px !important;
}

.control-link {
	font-size: 17px;
	color: #fff;
	transition: 0.3s all ease;
	margin-left: 10px;
}

.control-link:hover {
	transform: scale(1.2);
}

.control-link-active {
	font-size: 17px;
	color: #51c715;
	margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/story/StoryControls.vue